var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClose(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 20,
    viewBox: "0 0 20 20",
    width: 20,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m163.790909 23 5.685796-5.6857955c.697727-.6977272.697727-1.8289772 0-2.5272727l-1.263637-1.2636363c-.697727-.6977273-1.828977-.6977273-2.527273 0l-5.685795 5.6857954-5.685795-5.6857954c-.697728-.6977273-1.828978-.6977273-2.527273 0l-1.263637 1.2636363c-.697727.6977273-.697727 1.8289773 0 2.5272727l5.685796 5.6857955-5.685796 5.6857955c-.697727.6977272-.697727 1.8289772 0 2.5272727l1.263637 1.2636363c.697727.6977273 1.829545.6977273 2.527273 0l5.685795-5.6857954 5.685795 5.6857954c.697728.6977273 1.829546.6977273 2.527273 0l1.263637-1.2636363c.697727-.6977273.697727-1.8289773 0-2.5272727z",
    fill: "#ff3b30",
    fillRule: "evenodd",
    transform: "translate(-150 -13)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.cd9f155b.svg";
export { ForwardRef as ReactComponent };